import { createAssign } from "robodux";
import { select, put, call, delay } from "saga-query";
import { createSelector } from "reselect";
import { thunks } from "@app/state/apis/api";
import { selectCurrentGroupsTreeList } from "./groupstree";
import { selectDirInfoTypes } from "../directories";
import type { TDirinfo } from "@app/types";
import type { RootState } from "@app/state/rootState";
const REPO_UI_DIRS = "ui/dirinfo";

const initialDirInfo = {
  currentItem: undefined,
  data: [] as TDirinfo[],
};
export const uiDirifo = createAssign<typeof initialDirInfo>({
  name: REPO_UI_DIRS,
  initialState: initialDirInfo,
});

const selectDirInfoStore = (state: RootState) => state[REPO_UI_DIRS];

const selectDirInfoData = createSelector(
  selectDirInfoStore,
  (dirinfo) => dirinfo.data
);
const selectCurrentItem = createSelector(
  selectDirInfoStore,
  (dirinfo) => dirinfo.currentItem
);

// we create an empty dataset with all the dir types
// then we merge the data from the server into the dataset
export const selectGroupsDirInfo = createSelector(
  selectDirInfoData,
  selectCurrentGroupsTreeList,
  selectDirInfoTypes,
  (dirinfo, group, dirType) => {
    const { parentId, id } = group;
    const currentGroup = Number(parentId || id);
    const data = dirinfo
      .filter((item: TDirinfo) => Number(item.AGS_ID) === Number(currentGroup))
      .reduce((acc: any, item: TDirinfo) => {
        acc[item.DIR_TYPE] = item;
        return acc;
      }, {});
    const emptyDir = {
      SD_ID: -1,
      AGS_ID: currentGroup,
      DIR_TYPE: "",
      DIR_PATH: "",
      DIR_META: "",
    } as TDirinfo;
    const data1 = Object.values(dirType).reduce(
      (acc: any, item: any, i: number) => {
        acc[item.DIR_TYPE] = {
          ...item,
          ...emptyDir,
          SD_ID: -1 * i,
          ...data[item.DIR_TYPE],
        };
        return acc;
      },
      {}
    );

    return Object.values(data1 || {});
  }
);
